window.dataLayer = window.dataLayer || [];

document.onreadystatechange = () => {
    if (document.readyState !== 'complete') return false;
    initGTMTracking();
}

function initGTMTracking() {
    // 1. Rastreamento de Inscrição em Newsletter
    document.getElementsByName('mc-embedded-subscribe-form').forEach(form => {
        form.addEventListener('submit', event => {
            let email = event.target.querySelector('[name=EMAIL]') ? event.target.querySelector('[name=EMAIL]').value : null;
            let nome = event.target.querySelector('[name=NAME]') ? event.target.querySelector('[name=NAME]').value : 'estático';
            
            window.dataLayer.push({
                'event': 'cadastro_newsletter',
                'form_email': email, // Nota: Cuidado ao enviar e-mails abertos ao GA4 (viola políticas de PII). O ideal é hashear ou usar apenas para outras tags no GTM.
                'form_nome': nome
            });
        });
    });

    // 2. Rastreamento de Eventos em Elementos (Cliques, Scroll em elemento específico)
    // Recomendo trocar o atributo no HTML de 'data-ga4' para 'data-gtm' para fazer sentido, 
    // mas mantive 'data-ga4' aqui para não quebrar seu HTML atual de imediato.
    document.querySelectorAll('[data-ga4]').forEach(elem => {
        if (!elem.getAttribute('data-ga4')) return false;
        
        const dataGA = JSON.parse(elem.getAttribute('data-ga4'));
        const action = dataGA.event_type || 'click';

        // Scroll até um elemento específico
        if (action === 'scrollHere') {
            const handleScrollHere = () => {
                const offset = getOffset(elem);
                const scrollPosition = window.scrollY + window.innerHeight / 2; // Centro da tela
                if (scrollPosition >= offset.top) {
                    window.dataLayer.push({
                        'event': dataGA.event_name,
                        ...dataGA.event_parameters // Espalha os parâmetros dinamicamente
                    });
                    document.removeEventListener("scroll", handleScrollHere);
                }
            }
            document.addEventListener('scroll', handleScrollHere);
            return true;
        }

        // Outras ações (como clique)
        if (action !== 'pageview') { // Ignora pageviews aqui, o PHP fará isso (veja abaixo)
            elem.addEventListener(action, () => {
                window.dataLayer.push({
                    'event': dataGA.event_name,
                    ...dataGA.event_parameters
                });
            });
        }
    });

    // 3. Tracking de Scroll de Página (25, 50, 75, 100)
    window.addEventListener('scroll', handleScroll);
}

// --- FUNÇÕES AUXILIARES ---

function getOffset(el) {
    const rect = el.getBoundingClientRect();
    return {
        left: rect.left + window.scrollX,
        top: rect.top + window.scrollY
    }
}

function getScrollPercentage() {
    var scrollTop = window.pageYOffset;
    var windowHeight = window.innerHeight;
    var documentHeight = document.documentElement.scrollHeight;
    var scrolled = scrollTop / (documentHeight - windowHeight) * 100;
    return Math.round(scrolled);
}

// Otimização do código de scroll
var scrollMarks = { 25: false, 50: false, 75: false, 100: false };

function handleScroll() {
    var scrollPercentage = getScrollPercentage();
    
    [25, 50, 75, 100].forEach(mark => {
        if (scrollPercentage >= mark && !scrollMarks[mark]) {
            scrollMarks[mark] = true;
            window.dataLayer.push({
                'event': 'scroll_custom', // Nome do evento que vai acionar a Tag no GTM
                'percent_scrolled': mark
            });
        }
    });
}